import { SET_CP_CATEGORY } from "constants-lib/actionTypes"

export const setCPCategory = (category) => ({
  type: SET_CP_CATEGORY,
  payload: category,
})
